import {
  GET_SCHOOL_LIST,
  GET_SCHOOL_LIST_SUCCESS,
  GET_SCHOOL_LIST_FAILURE,
  CREATE_SCHOOL,
  CREATE_SCHOOL_SUCCESS,
  CREATE_SCHOOL_FAILURE,
  VIEW_SCHOOL,
  VIEW_SCHOOL_SUCCESS,
  VIEW_SCHOOL_FAILURE,
  GET_TEACHER_LIST,
  GET_TEACHER_LIST_SUCCESS,
  GET_TEACHER_LIST_FAILURE,
  CREATE_TEACHER,
  CREATE_TEACHER_FAILURE,
  CREATE_TEACHER_SUCCESS,
  GET_STUDENT_LIST,
  GET_STUDENT_LIST_SUCCESS,
  GET_STUDENT_LIST_FAILURE,
  VIEW_STUDENT,
  VIEW_STUDENT_SUCCESS,
  VIEW_STUDENT_FAILURE,
  UPDATE_STATUS_SCHOOL,
  UPDATE_STATUS_SCHOOL_SUCCESS,
  UPDATE_STATUS_SCHOOL_FAILURE,
  DELETE_TEACHER,
  DELETE_TEACHER_SUCCESS,
  DELETE_TEACHER_FAILURE,
  UPDATE_STATUS_TEACHER,
  UPDATE_STATUS_TEACHER_SUCCESS,
  UPDATE_STATUS_TEACHER_FAILURE,
  VIEW_TEACHER,
  VIEW_TEACHER_SUCCESS,
  VIEW_TEACHER_FAILURE,
  UPDATE_TEACHER,
  UPDATE_TEACHER_SUCCESS,
  UPDATE_TEACHER_FAILURE,
  VIEW_SCHOOL_DETAILES,
  VIEW_SCHOOL_DETAILES_SUCCESS,
  VIEW_SCHOOL_DETAILES_FAILURE,
  EDIT_SCHOOL,
  EDIT_SCHOOL_SUCCESS,
  EDIT_SCHOOL_FAILURE,  
  GET_COUNTRY_LIST_FAILURE,
  GET_COUNTRY_LIST_SUCCESS,
  GET_COUNTRY_LIST,
  GET_STATE_LIST_FAILURE,
  GET_STATE_LIST_SUCCESS,
  GET_STATE_LIST,
  GET_CITY_LIST_FAILURE,
  GET_CITY_LIST_SUCCESS,
  GET_CITY_LIST
} from "../../Actions/types";

const initialState = {
  createSchoolLoader: false,
  createSchoolError: false,
  createProductData: null,
  getSchoolListData: null,
  getSchoolListLoader: false,
  getSchoolListError: false,
  viewSchoolData: null,
  viewSchoolLoader: false,
  viewSchoolError: false,
  getTeacherListData: null,
  getTeacherListLoader: false,
  getTeacherListError: false,
  createTeacherLoader: false,
  createTeacherError: false,
  createTeacherData: null,
  getStudentListData: null,
  getStudentListLoader: false,
  getStudentListError: false,
  viewStudentData: null,
  viewStudentLoader: false,
  viewStudentError: false,
  updateStatusSchoolLoader: false,
  updateStatusSchoolData: null,
  updateStatusSchoolError: false,
  deleteTeacherLoader: false,
  deleteTeacherError: false,
  deleteTeacherData: null,
  updateStatusTeacherLoader: false,
  updateStatusTeacherData: null,
  updateStatusTeacherError: false,
  viewTeacherData: null,
  viewTeacherLoader: false,
  viewTeacherError: false,
  updateTeacherLoader: false,
  updateTeacherData: null,
  updateTeacherError: false,
  viewschooldetailes: null,
  viewschooldetailsloader: false,
  viewschooldetailserror: false,
  editschooldata: null,
  editschoolloader: false,
  editschoolerror: false,
  statedata: null,
  stateloader: false,
  editstateerror: false,
  getCountryListData: null,
  getCountryListLoader: false,
  getCountryListError: false,
  getStateListData: null,
  getStateListLoader: false,
  getStateListError: false,
  getCityListData: null,
  getCityListLoader: false,
  getCityListError: false,
};

function schoolManagementReducer(state = initialState, action) {
  // console.log(action, "action")
  switch (action.type) {
    case GET_SCHOOL_LIST:
      return { ...state, getSchoolListError: true };
    case GET_SCHOOL_LIST_SUCCESS:
      return {
        ...state,
        getSchoolListData: action?.payload,
        getSchoolListLoader: false,
      };
    case GET_SCHOOL_LIST_FAILURE:
      return { ...state, getSchoolListError: true, getSchoolListLoader: false };

    case CREATE_SCHOOL:
      return { ...state, createSchoolLoader: true };
    case CREATE_SCHOOL_SUCCESS:
      return {
        ...state,
        createSchoolData: action?.payload,
        createSchoolLoader: false,
      };
    case CREATE_SCHOOL_FAILURE:
      return {
        ...state,
        createSchoolLoader: false,
        createSchoolError: true,
      };

    case VIEW_SCHOOL:
      return { ...state, viewSchoolLoader: true };
    case VIEW_SCHOOL_SUCCESS:
      return {
        ...state,
        viewSchoolData: action?.payload,
        viewSchoolLoader: false,
      };
    case VIEW_SCHOOL_FAILURE:
      return {
        ...state,
        viewSchoolLoader: false,
        viewSchoolError: true,
      };

    case UPDATE_STATUS_SCHOOL:
      return { ...state, updateStatusSchoolLoader: true };
    case UPDATE_STATUS_SCHOOL_SUCCESS:
      return {
        ...state,
        updateStatusSchoolData: action?.payload,
        updateStatusSchoolLoader: false,
      };
    case UPDATE_STATUS_SCHOOL_FAILURE:
      return {
        ...state,
        updateStatusSchoolLoader: false,
        updateStatusSchoolError: true,
      };

    case GET_TEACHER_LIST:
      return { ...state, getTeacherListLoader: true };
    case GET_TEACHER_LIST_SUCCESS:
      return {
        ...state,
        getTeacherListLoader: false,
        getTeacherListData: action?.payload,
      };
    case GET_TEACHER_LIST_FAILURE:
      return {
        ...state,
        getTeacherListLoader: false,
        getTeacherListError: true,
        getTeacherListData: null,
      };

    case CREATE_TEACHER:
      return { ...state, createTeacherLoader: true };
    case CREATE_TEACHER_SUCCESS:
      return {
        ...state,
        createTeacherData: action?.payload,
        createTeacherLoader: false,
      };
    case CREATE_TEACHER_FAILURE:
      return {
        ...state,
        createTeacherLoader: false,
        createTeacherError: true,
      };

    case DELETE_TEACHER:
      return { ...state, deleteTeacherLoader: true };
    case DELETE_TEACHER_SUCCESS:
      return {
        ...state,
        deleteTeacherData: action?.payload,
        deleteTeacherLoader: false,
      };
    case DELETE_TEACHER_FAILURE:
      return {
        ...state,
        deleteTeacherLoader: false,
        deleteTeacherError: true,
      };

    case VIEW_TEACHER:
      return { ...state, viewTeacherLoader: true };
    case VIEW_TEACHER_SUCCESS:
      return {
        ...state,
        viewTeacherData: action?.payload,
        viewTeacherLoader: false,
      };
    case VIEW_TEACHER_FAILURE:
      return {
        ...state,
        viewTeacherLoader: false,
        viewTeacherError: true,
      };

    case UPDATE_TEACHER:
      return { ...state, updateTeacherLoader: true };
    case UPDATE_TEACHER_SUCCESS:
      return {
        ...state,
        updateTeacherData: action?.payload,
        updateTeacherLoader: false,
      };
    case UPDATE_TEACHER_FAILURE:
      return {
        ...state,
        updateTeacherLoader: false,
        updateTeacherError: true,
      };

    case UPDATE_STATUS_TEACHER:
      return { ...state, updateStatusTeacherLoader: true };
    case UPDATE_STATUS_TEACHER_SUCCESS:
      return {
        ...state,
        updateStatusTeacherData: action?.payload,
        updateStatusTeacherLoader: false,
      };
    case UPDATE_STATUS_TEACHER_FAILURE:
      return {
        ...state,
        updateStatusTeacherLoader: false,
        updateStatusTeacherError: true,
      };

    case GET_STUDENT_LIST:
      return { ...state, getStudentListError: true };
    case GET_STUDENT_LIST_SUCCESS:
      return {
        ...state,
        getStudentListData: action?.payload,
        getStudentListLoader: false,
      };
    case GET_STUDENT_LIST_FAILURE:
      return {
        ...state,
        getStudentListError: true,
        getStudentListLoader: false,
      };

    case VIEW_STUDENT:
      return { ...state, viewStudentLoader: true };
    case VIEW_STUDENT_SUCCESS:
      return {
        ...state,
        viewStudentData: action?.payload,
        viewStudentLoader: false,
      };
    case VIEW_STUDENT_FAILURE:
      return {
        ...state,
        viewStudentLoader: false,
        viewStudentError: true,
      };

    case VIEW_SCHOOL_DETAILES:
      return {
        ...state,
        viewschooldetailsloader: true,
      };

    case VIEW_SCHOOL_DETAILES_SUCCESS:
      return {
        ...state,
        viewschooldetailsloader: false,
        viewschooldetailes: action?.payload,
      };

    case VIEW_SCHOOL_DETAILES_FAILURE:
      return {
        ...state,
        viewschooldetailsloader: false,
        viewschooldetailserror: true,
      }; 

    case EDIT_SCHOOL:
      return {
        ...state,

        editschoolloader: true,
      };

    case EDIT_SCHOOL_SUCCESS:
      return {
        ...state,

        editschoolloader: false,
        editschooldata: action?.payload,
      };

    case EDIT_SCHOOL_FAILURE:
      return {
        ...state,
        editschoolloader: false,
        editschoolerror: true,
      };

 
        case GET_COUNTRY_LIST:
          return { ...state, getCountryListError: true };
        case GET_COUNTRY_LIST_SUCCESS:
          return {
            ...state,
            getCountryListData: action?.payload,
            getCountryListLoader: false,
          };
        case GET_COUNTRY_LIST_FAILURE:
          return {
            ...state,
            getCountryListError: true,
            getCountryListLoader: false,
          };

    
    
          case GET_STATE_LIST:
            return { ...state, getStateListError: true };
          case GET_STATE_LIST_SUCCESS:
            return {
              ...state,
              getStateListData: action?.payload,
              getStateListLoader: false,
            };
          case GET_STATE_LIST_FAILURE:
            return {
              ...state,
              getStateListError: true,
              getStateListLoader: false,
            };
    
            case GET_CITY_LIST:
              return { ...state, getCityListError: true };
            case GET_CITY_LIST_SUCCESS:
              return {
                ...state,
                getCityListData: action?.payload,
                getCityListLoader: false,
              };
            case GET_CITY_LIST_FAILURE:
              return {
                ...state,
                getCityListError: true,
                getCityListLoader: false,
              };
      


    default:
      return state;
  }
}

export default schoolManagementReducer;
